var canvas = document.getElementById('spraypaint');
var mobilecanvas = document.getElementById('spraypaint');
var _docHeight = (document.height !== undefined) ? document.height : document.body.offsetHeight;
var _docWidth = (document.width !== undefined) ? document.width : document.body.offsetWidth;

// var debug = document.getElementById("mobile-debug")

canvas.width = _docWidth;
canvas.setAttribute("width", _docWidth);
canvas.height = _docHeight - 50;
canvas.setAttribute("height", _docHeight - 50);

mobilecanvas.width = _docWidth;
mobilecanvas.height = window.innerHeight;

var ctx = canvas.getContext('2d');
var ctx2 = mobilecanvas.getContext('2d');
// var trail_colors = ['#b0a0c9', '#e6c1c4', '#c45928', '#f7e0f9', '#f1eee5']


trail_colors = trail_colors.filter(c => c.indexOf("rgba") === -1).map((color) => {
  var total = Number("0x"+color.slice(1))
  var rgb = [];
  var b = total % (16*16);
  total -= b;
  var g = total % (16*16*16*16) / (16*16);
  total -= g;
  var r = total % (16*16*16*16*16*16) / (16*16*16*16);
  return [Math.floor(r),Math.floor(g),Math.floor(b)];
})

var colorSteps = [0,0,0];
var trail_color = 0;
var colorInterval = trail_period;

var rgb = trail_colors[trail_color];



function calculateColorSteps(){
  var color1 = trail_colors[trail_color % trail_colors.length];
  var color2 = trail_colors[(trail_color+1) % trail_colors.length];
  for (var i = 0; i < 3; i++) {
    colorSteps[i] = (color2[i] - color1[i])/colorInterval;
  }
}

var red = 0;
var green = 0;
var blue = 0;
var colorCount = 0;
window.points = []
var ctx = canvas.getContext('2d');

function num(range){
  return Math.floor(Math.random()*range)
}
var fwRange = 50;
var fwSize = 10;

function drawLine(p1,p2,width,ctx){
  ctx.beginPath()
  ctx.lineWidth = width;
  ctx.strokeStyle = rgba();
  ctx.moveTo(p1[0],p1[1])
  var a = p1[0] - p2[0]
  var b = p1[1] - p2[1]
  if(Math.sqrt(a*a+b*b)>100)
    ctx.moveTo(p2[0],p2[1]);
  ctx.lineTo(p2[0],p2[1])
  ctx.stroke();
  ctx.closePath()
}

function rgba(){
  return `rgb(${Math.floor(rgb[0])}, ${Math.floor(rgb[1])}, ${Math.floor(rgb[2])})`;
}

function hoverColor(e){
  e.target.classList.add("link-hover")
  e.target.setAttribute("data-color",e.target.style.color)
  e.target.style.color = rgba()
  if($(e.target).find(".arrow")){
    $(e.target).find(".arrow").css("background",rgba())
  }
}

function dehoverColor(e){
  e.target.classList.remove("link-hover")
  e.target.style.color = e.target.getAttribute("data-color")
  if($(e.target).find(".arrow")){
    $(e.target).find(".arrow").css("background","black")
  }
}

function hoverButtonColor(e){
  e.target.classList.add("button-hover")
  e.target.setAttribute("data-text-color",e.target.style.color)
  e.target.setAttribute("data-bg-color",e.target.style.backgroundColor)
  e.target.style.backgroundColor = rgba()
  e.target.style.color = "white"
}

function dehoverButtonColor(e){
  e.target.classList.remove("button-hover")
  e.target.style.backgroundColor = e.target.getAttribute("data-bg-color")
  e.target.style.color = e.target.getAttribute("data-text-color")
}

let trail_thickness = (trailBlurSize ? trailBlurSize : 2);
console.log({
  trailBlurSize,
  maxTrailLength,
  trail_period,
  trail_colors,
})
let maxLineLength = window.maxTrailLength;

function drawTrail(e){
  if (canvas.getContext && window.allowTrail) {
    ctx.clearRect(0,0,_docWidth*2,_docHeight*2);
    points.push([e.clientX,e.clientY])
    if(rgb)
    rgb = rgb.map((r,i) => {
      return (r+colorSteps[i])
    })
    for (var i = 1; i < points.length-2; i++) {
      drawLine(points[i],points[i+1],
        (i+15 < maxLineLength ? i : i+(maxLineLength - 15-i))*(trail_thickness),
        ctx)
    }
    if(points.length > maxLineLength)
      points.shift()
    }
    if(colorCount % colorInterval === 0){
      calculateColorSteps();
      trail_color = (trail_color+1) % trail_colors.length;
    }
    colorCount++;
}

// debug.innerHTML = `hello`
var touchStarts = []
var clickedWindowOffset, clickedClientOffset;
function startDrawTrailMobile(e){

  if(e.targetTouches.length){
    // points.push([e.targetTouches[0].pageX,e.targetTouches[0].pageY]);
    touchStarts = [e.targetTouches[0].clientY,window.pageYOffset]
    clickedWindowOffset = window.pageYOffset;
    clickedPageOffset = e.targetTouches[0].pageY;
    points = []
    console.log("added ",window.pageYOffset)
    // debug.innerHTML = `${points}`
  }
}

function copyDrawTrailMobile(){
  ctx.drawImage(mobilecanvas, 0, window.pageYOffset+(window.outerHeight-window.innerHeight));
  ctx2.clearRect(0,0,mobilecanvas.width,mobilecanvas.height)
}

function drawTrailMobile(e){
  if (canvas.getContext) {
    // ctx.clearRect(0,0,_docWidth,_docHeight);
    if(e.targetTouches.length){
      var newPt = [ e.targetTouches[0].clientX, e.targetTouches[0].pageY] //-difference[1]/2
      newPt = [ e.targetTouches[0].clientX, clickedPageOffset + (window.pageYOffset - clickedWindowOffset)]
      newPt = [e.targetTouches[0].clientX,e.targetTouches[0].clientY]
      points.push(newPt)
      // debug.innerHTML = `pt: ${newPt[0] + " "+newPt[1]}<br>points: ${points.length}, <br>client: ${e.targetTouches[0].clientY}`
    }
    rgb = rgb.map((r,i) => {
      return (r+colorSteps[i])
    })
    var totalLength = 0;
    for (var i = 0; i < points.length-1; i++) {
      drawLine(points[i],points[i+1],(trail_thickness),ctx2)
    }

    // if(points.length > 50)
    //   points.shift()
    }
    if(colorCount % colorInterval === 0){
      calculateColorSteps();

      trail_color = (trail_color+1) % trail_colors.length;
    }
    colorCount++;
}


if(trail_colors.length && trail_colors.length > 0){
  window.addEventListener('touchstart', startDrawTrailMobile, {passive: true});
  window.addEventListener('touchend', copyDrawTrailMobile, {passive: true});
  window.addEventListener('touchmove', drawTrailMobile, {passive: true});
  window.addEventListener('mousemove', drawTrail, {passive: true});
}
